import React, { useEffect, useRef } from 'react';
import './Hero.css';

const Hero = () => {
  const heroBackgroundRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (heroBackgroundRef.current) {
        const scrolled = window.pageYOffset;
        heroBackgroundRef.current.style.transform = `translateY(${scrolled * 0.5}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="hero" id="hero">
      <div className="hero-background" ref={heroBackgroundRef}></div>
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-wrapper">
          <div className="hero-content">
            <div className="hero-header">
              {/* <div className="hero-location">
                <span className="location-text">IN</span>
                <span className="location-divider">×</span>
                <span className="location-text">US</span>
              </div> */}
              <div className="hero-collab">
                <img src="/images/india-flag.png" alt="India Flag" className="flag-icon" />
                <span className="collab-divider">×</span>
                <img src="/images/usa-flag.png" alt="USA Flag" className="flag-icon" />
              </div>
            </div>
            
            <div className="hero-badge">
              <span className="badge-dot">●</span> Only 50 Seats Available - Limited Time Offer
            </div>

            <h1 className="hero-title">
              AMERICA NEEDS<br />
              <span className="title-highlight">PILOTS</span>
            </h1>
            
            <p className="hero-subtitle">
              Get <span className="highlight">CPL + CFI + CFII + ATP</span> with <span className="highlight">BSc Aeronautics</span> from Embry-Riddle University
            </p>
            
            <div className="hero-features">
              <div className="hero-feature">
                <span className="feature-icon">✓</span>
                <span className="feature-text">Earn While You Learn</span>
              </div>
              <div className="hero-feature">
                <span className="feature-icon">✓</span>
                <span className="feature-text">4000+ Flight Hours</span>
              </div>
              <div className="hero-feature">
                <span className="feature-icon">✓</span>
                <span className="feature-text">Assured Job in USA</span>
              </div>
            </div>

            <div className="hero-cta">
              <a href="#apply" className="btn btn-primary" onClick={(e) => scrollToSection(e, 'apply')}>
                Check Eligibility Now <span className="arrow">→</span>
              </a>
              <a href="#program" className="btn btn-secondary" onClick={(e) => scrollToSection(e, 'program')}>
                Learn More <span className="arrow-down">⌄</span>
              </a>
            </div>
          </div>

          <div className="hero-stats">
            <div className="stat-box">
              <div className="stat-value">$65k</div>
              <div className="stat-label">CPL Investment</div>
            </div>
            <div className="stat-box">
              <div className="stat-value">$350K</div>
              <div className="stat-label">Earn</div>
            </div>
            <div className="stat-box">
              <div className="stat-value">4000+</div>
              <div className="stat-label">Flight Hours</div>
            </div>
            <div className="stat-box">
              <div className="stat-value">100%</div>
              <div className="stat-label">Assured Job in USA</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
